import { render, staticRenderFns } from "./AddScoreRecord.vue?vue&type=template&id=885799ca&scoped=true"
import script from "./AddScoreRecord.vue?vue&type=script&lang=js"
export * from "./AddScoreRecord.vue?vue&type=script&lang=js"
import style0 from "./AddScoreRecord.vue?vue&type=style&index=0&id=885799ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885799ca",
  null
  
)

export default component.exports